export const en = {
  taskElementTitle: `💡 Here's the feedback!`,
  taskElementDescription: `It's now a task in your project board and includes a screenshot and
            other metadata captured by BugHerd.`,
  taskElementAction: 'Click it to see more.',
  taskDetailsTitle: '💡 BugHerd captured all the technical details for you',
  taskDetailsDescription: `This includes a screenshot, the URL of the page, plus additional
            info like the browser detail as and operating system.`,
  next: 'Next',
  shareButtonTitle: '🎉 Share with your client when you are ready',
  shareButtonAction1: `Ready to share with your Client? Click 'Share'.`,
  shareButtonAction2: `Or click 'Finish Tour' to continue exploring BugHerd.`,
  finishTour: 'Finish Tour',
  setupGuideTitle: '🎉 Your walkthrough of BugHerd is complete!',
  setupGuideDescription: `Click the Setup guide link to finish setting up your Project. You can complete it now, or return to it at any time.`
};
export type Translations = typeof en;
